var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFiltersDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3px",
    height: "13px",
    viewBox: "0 0 3 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tabel-/-Tehing-/-Header",
    transform: "translate(-262.000000, -18.000000)",
    fill: "#C1C1C1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.5,21 C262.671573,21 262,20.3284271 262,19.5 C262,18.6715729 262.671573,18 263.5,18 C264.328427,18 265,18.6715729 265,19.5 C265,20.3284271 264.328427,21 263.5,21 Z M263.5,31 C262.671573,31 262,30.3284271 262,29.5 C262,28.6715729 262.671573,28 263.5,28 C264.328427,28 265,28.6715729 265,29.5 C265,30.3284271 264.328427,31 263.5,31 Z M263.5,26 C262.671573,26 262,25.3284271 262,24.5 C262,23.6715729 262.671573,23 263.5,23 C264.328427,23 265,23.6715729 265,24.5 C265,25.3284271 264.328427,26 263.5,26 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFiltersDots);
export default __webpack_public_path__ + "static/media/Icon_Filters_Dots.11ce9adb5788bd4a40852facf2a34107.svg";
export { ForwardRef as ReactComponent };